export class Api {
    protected URL = 'https://api.parfum-atelier.com'
}